import { useState } from "react"
import { ComponentModel, NewsletterFeedComponent } from "template/components"

import Button from "components/base/Button"

const NewsletterFeedEditor = ({
    parent,
    component,
    save,
}: {
    parent: ComponentModel
    component: NewsletterFeedComponent
    save: () => void
}) => {
    const [componentType, setComponentType] = useState<any>("list")
    const [componentID, setComponentID] = useState<string>("")

    const removeComponent = (index: number) => {
        component.components?.splice(index, 1)
        save()
    }
    const addComponent = () => {
        let new_component = {
            type: componentType,
            id: componentType === "single" ? componentID : "",
            components: [],
        }
        component.components?.push(new_component)
        save()
    }

    return (
        <div>
            <p>NewsEditor</p>
            {component.components === null ? (
                <div>No components</div>
            ) : (
                component.components?.map((v, i) => {
                    return (
                        <div key={i} className="grid my-4">
                            {v.type}
                            <Button
                                onClick={() => {
                                    removeComponent(i)
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    )
                })
            )}
            <form
                onSubmit={(e) => {
                    e.preventDefault()
                    addComponent()
                }}
            >
                <select value={componentType} onChange={(e) => setComponentType(e.target.value)}>
                    <option selected value={"list"}>
                        List
                    </option>
                    <option value={"single"}>single</option>
                </select>
                {componentType === "single" ? (
                    <div>
                        <input
                            type="text"
                            placeholder="newsletter_id"
                            value={componentID}
                            onChange={(e) => setComponentID(e.target.value)}
                        />
                    </div>
                ) : (
                    ""
                )}
                <div>
                    <input type="submit" value="add"></input>
                </div>
            </form>
        </div>
    )
}

export default NewsletterFeedEditor
